import * as React from "react";

const LinkedinIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="42"
        fill="none"
        viewBox="0 0 50 50"
    >
        <rect width="50" height="50" fill="#36387D" rx="8"></rect>
        <g clipPath="url(#clip0_2947_4135)">
            <path
                fill="#fff"
                d="M36.143 12c.986 0 1.857.87 1.857 1.915v22.228C38 37.187 37.13 38 36.143 38H13.799C12.813 38 12 37.188 12 36.143V13.915c0-1.044.813-1.915 1.8-1.915zM19.835 34.286V21.924h-3.83v12.362zM17.92 20.183a2.204 2.204 0 0 0 2.205-2.205c0-1.22-.987-2.264-2.205-2.264a2.266 2.266 0 0 0-2.264 2.264c0 1.218.987 2.205 2.264 2.205m16.366 14.103v-6.79c0-3.308-.755-5.92-4.643-5.92-1.857 0-3.134 1.044-3.656 2.031h-.058v-1.683h-3.657v12.362h3.83v-6.094c0-1.625.29-3.192 2.322-3.192 1.973 0 1.973 1.857 1.973 3.25v6.036z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_2947_4135">
                <path fill="#fff" d="M12 12h26v26H12z"></path>
            </clipPath>
        </defs>
    </svg>
);

export default LinkedinIcon;
